import * as React from "react";
import { SVGProps, memo } from "react";

const SvgTel = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.48 2.401a1 1 0 0 1 .9.743l1 3.798a1 1 0 0 1-.432 1.1L5.361 9.682c.523 1.24 1.138 2.235 1.904 3.052.817.766 1.813 1.381 3.052 1.905l1.642-2.588a1 1 0 0 1 1.099-.431l3.798.999a1 1 0 0 1 .743.9l.218 3.236a.993.993 0 0 1-1.177 1.045c-4.48-.866-8.069-1.918-10.294-3.882l-.01.011a8.195 8.195 0 0 1-.13-.137 8.199 8.199 0 0 1-.136-.129l.01-.01C4.118 11.429 3.067 7.84 2.2 3.36a.993.993 0 0 1 1.044-1.177l3.236.218Zm.356 4.57L4.827 8.244c-.41-1.253-.765-2.712-1.107-4.421l2.31.084.806 3.063Zm6.194 6.193-1.275 2.009c1.253.41 2.712.765 4.422 1.107l-.085-2.31-3.062-.806Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgTel);

export default Memo;
